export var UserGroups;
(function (UserGroups) {
    /**
     * Our internal support team
     */
    UserGroups["OTUVY_TECH_SUPPORT"] = "otuvy_tech_support";
    UserGroups["SUPER_ADMIN"] = "super_admin";
    UserGroups["PEOPLE_MANAGER"] = "people_manager";
    UserGroups["TIME_TRACKING"] = "time_tracking";
    UserGroups["LIST_MANAGER"] = "list_manager";
    UserGroups["QM_INTEGRATION_MANAGER"] = "qm_integration_manager";
    /**
     * Prevents access to VeriTask app specifically
     * Still allows access to admin portal
     * This is used as part of billing being overdue
     */
    UserGroups["NO_APP_ACCESS"] = "no_app_access";
})(UserGroups || (UserGroups = {}));
/**
 * TODO: This is a temporary solution to map the user group strings to their IDs
 */
export var UserGroupToIdMap = {
    "otuvy_tech_support": 1,
    "super_admin": 2,
    "people_manager": 3,
    "time_tracking": 4,
    "list_manager": 5,
    "qm_integration_manager": 8,
    "no_app_access": 9,
};
export function isGroupInGroupList(groupToCheck, groupList) {
    console.log('Checking if user is in group', groupToCheck);
    if (!groupList) {
        return false;
    }
    return groupList.includes(groupToCheck);
}
export function isAnyGroupInGroupList(groupsToCheck, groupList, includeTechSupport) {
    if (includeTechSupport === void 0) { includeTechSupport = true; }
    if (!groupList) {
        console.log('No user group cache when verifying any group membership');
        return false;
    }
    if (groupsToCheck.length === 0)
        return false;
    if (includeTechSupport && groupsToCheck.includes(UserGroups.OTUVY_TECH_SUPPORT)) {
        console.log('User is in tech support group when checking if they are in any group');
        return true;
    }
    for (var _i = 0, groupsToCheck_1 = groupsToCheck; _i < groupsToCheck_1.length; _i++) {
        var group = groupsToCheck_1[_i];
        if (groupList.includes(group)) {
            return true;
        }
    }
    return false;
}
export function isEveryGroupInGroupList(groupsToCheck, groupList, includeTechSupport) {
    if (includeTechSupport === void 0) { includeTechSupport = true; }
    console.log('Checking if user is in every group', groupsToCheck);
    if (!groupList) {
        return false;
    }
    if (groupsToCheck.length === 0)
        return false;
    if (includeTechSupport && groupList.includes(UserGroups.OTUVY_TECH_SUPPORT)) {
        console.log('User is in tech support group when checking if they are in every group');
        return true;
    }
    for (var _i = 0, groupsToCheck_2 = groupsToCheck; _i < groupsToCheck_2.length; _i++) {
        var group = groupsToCheck_2[_i];
        if (!groupList.includes(group)) {
            console.log("User is not in group ".concat(group, " when checking if they are in every"), groupsToCheck);
            return false;
        }
    }
    return true;
}
export function isUserAdmin(groupsToCheck) {
    return isAnyGroupInGroupList([UserGroups.OTUVY_TECH_SUPPORT,
        UserGroups.SUPER_ADMIN,
        UserGroups.PEOPLE_MANAGER,
        UserGroups.TIME_TRACKING,
        UserGroups.LIST_MANAGER,
        UserGroups.QM_INTEGRATION_MANAGER], groupsToCheck);
}
function getEnumKeyByValue(value) {
    //We *could* get a faster version with a manually maintained map, but this is more dynamic
    var enumKey = Object.keys(UserGroups).find(function (key) { return UserGroups[key] === value; });
    var result = enumKey ? UserGroups[enumKey] : undefined;
    return result;
}
export function convertUserGroupStringToEnum(values) {
    if (!values)
        return [];
    var groups = [];
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var group = values_1[_i];
        var enumValue = getEnumKeyByValue(group);
        if (enumValue)
            groups.push(enumValue);
    }
    return groups;
}
export function getUserGroupId(group) {
    var groupKey = group;
    var id = UserGroupToIdMap[groupKey];
    if (id === undefined) {
        throw new Error("No ID found for UserGroup: ".concat(groupKey));
    }
    return id;
}
